import { EUWA } from '@puzzel/euwa-wrapper';

import { getClubByHyphenatedClubName } from 'src/content/club-look-ups-by-id';
import type { OnCookieConsentChangeArgs } from 'src/cookies/cookie-consent-banner';
import { amplitudeTrackEvent } from 'src/helpers/amplitude-event-track';
import { generalAllowedAllConsentCookieOnChange } from 'src/helpers/chat-helper';
import { getPuzzelConfig } from 'src/helpers/config-helper';
export const PUZZEL_CHAT_CLASS = 'show-live-chat';

let euwa: EUWA | undefined;
let variablesCapturedBeforeInitialisation: ChatVariables;

const init = () => {
  euwa = new EUWA(getPuzzelConfig());

  setupChatEventTracking();
  if (variablesCapturedBeforeInitialisation) {
    updateChatVariables(variablesCapturedBeforeInitialisation);
  }
  return;
};

type ChatVariables = {
  page?: string;
};

type PuzzelChatVariables = {
  'Page'?: string;
  'Club name'?: string;
};

export const updateChatVariables = (variables: ChatVariables) => {
  if (!euwa) {
    variablesCapturedBeforeInitialisation = variables;
    return;
  }
  void euwa.getApplication(EUWA.APPS.CHAT).then((chat) => {
    const chatVariables: PuzzelChatVariables = {};
    if (variables.page) {
      chatVariables.Page = variables.page;
      const regex = '/clubs/([^/]*)/';
      const hyphenatedClubName = variables.page.match(regex);
      if (hyphenatedClubName) {
        chatVariables['Club name'] = getClubByHyphenatedClubName(hyphenatedClubName[1])?.clubName;
      }
    }
    chat.api.updateVariables(chatVariables);
  });
};

const setupChatEventTracking = () => {
  void euwa!.getApplication(EUWA.APPS.CHAT).then((chat) => {
    //Link to docs: https://help.puzzel.com/product-documents/user-guide/puzzel-contact-centre/puzzel-administration-portal/services/chat-configuration-old-version/chat-front-end-api
    chat.subscribe('chatWindowShown', () => {
      void amplitudeTrackEvent('Click to CTA - Chat window has been opened');
    });
    chat.subscribe('chatStarts', () => {
      void amplitudeTrackEvent('Click to CTA - Chat has been started');
    });
  });
};

const allowedAllConsentCookieOnChange = (consentChange: OnCookieConsentChangeArgs) =>
  generalAllowedAllConsentCookieOnChange('[data-puzzel-chat]', PUZZEL_CHAT_CLASS)(consentChange);

export default { init, allowedAllConsentCookieOnChange };
